module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "about-us "
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8649462e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/payment/donation.vue
// module id = 574
// module chunks = 0